module.exports = __webpack_public_path__ + "offer-analysis-detail.svg?523917e72eaa95dd675ab87155a1f475";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/offer-analysis-detail.svg
// module id = 300
// module chunks = 2